import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    themeId: localStorage.getItem('theme') || 'navy', // use saved theme or default
};

const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.themeId = action.payload;
        },
    },
});

export const { setTheme } = themeSlice.actions;
export default themeSlice.reducer;
